import {AxiosInstance} from 'axios'

import {QueryKey} from '../hooks/useUpmStructure'
import {PlantNode} from '../types'

type FetchUpmStructureArgs = {
  plantId: string
  includeEquipment?: boolean
  axiosInstance: AxiosInstance
}

export const getQueryKeyUpmStructure = (plantId: string) => [QueryKey, plantId]

export const fetchUpmStructure = async ({
  plantId,
  includeEquipment = true,
  axiosInstance
}: FetchUpmStructureArgs): Promise<PlantNode> => {
  const path = `/upm/plants/${plantId}/structure`
  const response = await axiosInstance.get<PlantNode>(path, {
    params: {includeEquipment}
  })

  return response.data
}
